<template>
  <Transition name="fade" appear>
    <SiteNav v-if="navVisible" />
  </Transition>
  <template v-if="appReady">
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" :key="routeKey" />
      </Transition>
    </RouterView>
    <SiteFooter />
  </template>
  <main v-else id="main">
    <Loader class="--page" />
  </main>
  <Gdpr />
</template>

<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import { SiteNav } from '@/components/navigation'
import { SiteFooter } from '@/components/sections'
import { Loader } from '@/components/small'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: {
    Gdpr,
    Loader,
    SiteFooter,
    SiteNav,
  },
  data() {
    return {
      appReady: false,
      navVisible: false,
    }
  },
  computed: {
    routeKey() {
      return this.$route.name === 'activities' ? this.$route.name : this.$route
    },
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.appReady = false
        this.$beet
          .fetchCoreData(to)
          .then(() => this.$store.dispatch('setCategories', Object.values(this.$beet.categories)))
          .then(() => this.$store.dispatch('setActivities', Object.values(this.$beet.activities)))
          .then(() => this.$store.dispatch('setNavItems', this.$store.state.categories.items))
          .then(() => {
            this.appReady = true
          })
      },
      immediate: true,
    },
  },
  mounted() {
    requestAnimationFrame(() => {
      this.navVisible = true
    })
  },
  updated() {
    this.$nextTick(() => {
      const el = this.$route.hash ? document.querySelector(this.$route.hash) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    })
  },
}
</script>
